export default __webpack_public_path__ + "static/media/4.668c0b7d.png";